import { IsEnum, IsNotEmpty } from 'class-validator';
import { UsuarioBackofficeTipo } from '.';

export class UsuarioBackofficeUpdateDto {
  @IsEnum(UsuarioBackofficeTipo)
  @IsNotEmpty()
  tipo: UsuarioBackofficeTipo;
}
